import { createSubjects } from "@openauthjs/openauth/subject";
import { object, optional, picklist, string } from "valibot";
export const subjects = createSubjects({
    user: object({
        id: string(),
        phone: string(),
        role: picklist(["admin", "user"]),
        // Optional active-team hint. The issuer (KV-only) cannot resolve teams, so
        // production tokens omit it; the api resolves the team server-side. Kept in
        // the schema so local-dev tokens / future flows may carry it.
        defaultTeamId: optional(string()),
    }),
});
export function normalizeColombianPhone(input) {
    const digits = input.replace(/\D/g, "");
    if (digits.length === 10 && digits.startsWith("3"))
        return "57" + digits;
    if (digits.length === 12 && digits.startsWith("57") && digits[2] === "3")
        return digits;
    return null;
}
export async function deriveUserId(normalizedPhone) {
    const data = new TextEncoder().encode(normalizedPhone);
    const hash = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hash).slice(0, 12))
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
}
//# sourceMappingURL=index.js.map